import {Icon} from '@wandb/weave/components/Icon';
import React, {memo, useContext} from 'react';

import {useViewerUserInfoQuery} from '../../../generated/graphql';
import {useViewer} from '../../../state/viewer/hooks';
import {useRampFlagAccountSelector} from '../../../util/rampFeatureFlags/rampFeatureFlags';
import {isInIframe} from '../../../util/window';
import {useNavContext} from '../../NavContextProvider';
import {RunQueueItemPopover} from '../../RunQueueItemsPopover';
import {WBAgent} from '../../WBAgent/WBAgent';
import {AccountSelectorContext} from './AccountSelectorContextProvider';
import InviteTeammatesButton from './InviteTeammatesButton';
import NavResources from './NavResources';
import NavSearchButton from './NavSearchButton';
import NavWhatsNewButton from './NavWhatsNewButton';
import ProfileMenu from './ProfileMenu';
import {ProfileMenuContextProvider} from './ProfileMenuContextProvider';
import {useIsSignupRoute} from './profileMenuUtils';
import * as S from './SearchNav.styles';
import {AccountType} from './types';

const NavRightComp = () => {
  const isSignup = useIsSignupRoute();
  const {searchData: data} = useNavContext();
  const viewer = useViewer();
  const enableAccountSelector = useRampFlagAccountSelector();
  const {selectedAccount} = useContext(AccountSelectorContext);

  const viewerUserInfo = useViewerUserInfoQuery();
  const userInfo = viewerUserInfo?.data?.viewer?.userInfo;
  const shouldHidePersonalEntity = userInfo?.isPersonalEntityHidden ?? false;
  const isPersonalEntitySelectedAccount =
    selectedAccount !== null &&
    selectedAccount.accountType === AccountType.Personal;
  const canViewNavBarTools = !(
    shouldHidePersonalEntity && isPersonalEntitySelectedAccount
  );

  return isInIframe() ? (
    <S.OpenPageLink
      href={document.location.href.replace('jupyter=true', '')} // TODO: actually parse the query and handle other flags?
    >
      Open page <Icon style={{marginLeft: 5}} name="forward-next" />
    </S.OpenPageLink>
  ) : (
    <>
      {canViewNavBarTools && (
        <>
          {viewer != null &&
            enableAccountSelector &&
            selectedAccount?.accountType === AccountType.Personal && (
              <InviteTeammatesButton />
            )}
          {viewer != null && (
            <>
              {!isSignup && data != null && <NavSearchButton />}
              <RunQueueItemPopover />
            </>
          )}
          <NavWhatsNewButton />
          <NavResources />
          <WBAgent />
        </>
      )}
      <ProfileMenuContextProvider>
        <ProfileMenu />
      </ProfileMenuContextProvider>
    </>
  );
};

const NavRight = memo(NavRightComp);

export default NavRight;
